import type React from "react";

interface EvlIconProps extends React.SVGProps<SVGSVGElement> {
    color?: string;
}

export const EvlIcon: React.FC<EvlIconProps> = ({ color = "black", ...svgProps }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
        <path
            d="M4.5 11.757C4.5 7.61487 7.85786 4.257 12 4.257C16.1421 4.257 19.5 7.61487 19.5 11.757"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.49999 11.757C2.40201 11.7571 0.660617 13.3782 0.510488 15.4708C0.360359 17.5634 1.85251 19.4164 3.92899 19.716C4.0734 19.7367 4.21965 19.6933 4.32941 19.5972C4.43916 19.5011 4.50147 19.3619 4.49999 19.216V11.757Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5 11.757C21.6404 11.7608 23.3986 13.4488 23.4894 15.5873C23.5802 17.7258 21.9714 19.5568 19.839 19.742C19.7519 19.7496 19.6655 19.7202 19.6011 19.6611C19.5366 19.6019 19.5 19.5185 19.5 19.431L19.5 11.757Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.5 16.257H16L14.5 19.257L13 12.257L11 17.257L9.5 14.257L8 16.257H6.5"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
